import translate from "../../../i18n/translate";
import moment from "moment";
import React from "react";


// solo sprint re-formated data
export function afterGetLearnerProgressDetails (learnerData: any, productId: string) {    
    let getLearnerProgressModuleDetails: any = learnerData;
    let courseModuleObj: any = [];
    let perPartTotalExercise: number = 0;
    let perPartCompletedExercise: number = 0;
    let perPartTotalSession: number = 0;
    let perPartCompletedSession: number = 0;
    let perPartTotalCorrectnessPercentage: number = 0;
    let perPartUserScore: number = 0;   
    let perPartMaxScore: number = 0;
    let perPartSessionDetail: string = "";
    getLearnerProgressModuleDetails.map((courseModule: any) => {
        let courseMainTitle = courseModule?.coursePart?.title,
        courseMainUnitList = courseModule?.units?.length && courseModule?.units,
        courseExist: boolean = false,
        isDigitalTest: Boolean = false,
        courseIndex: number = 0,
        perModuleTotalExercise: number = 0,
        perModulecompletedExercise: number = 0,
        perModuleCompletedPercent: string = "",
        perModuleExerciseDetail: string = "",
        perModuleTotalSession: number = 0,
        perModulecompletedSession: number = 0,
        perModuleSessionPercent: string = "",
        perModuleSessionDetail: string = "",
        perModuleTotalCorrectnessPercentage: number = 0,
        perModuleCorrectnessPercentage: number = 0,
        courseUnitObj: any = [],              
        cumulativeTestResults: any = {
        type: "digital_test",
        UserScore: 0,
        MaxScore: 0
        },       
        cumulativeSessionUnits: any = { 
        "type": "unit",
        "perUnitTotalSession" : 0,
        "perUnitcompletedSession" : 0          
        }, 
        courseDetailObj = {
        ...courseModule,
        units: courseUnitObj
        };
         
        courseMainUnitList.map((courseUnit: any, courseUnitIndex: number) => {
        const courseMainLearningObjectsList = courseUnit?.learningObjects.length && courseUnit?.learningObjects;
        courseMainLearningObjectsList.map((courseLearning: any) => {
            isDigitalTest = courseLearning.type === "digital_test" ? true  : false;        
            if (!isDigitalTest) {          
            if(courseLearning.type === "lesson"){
                let totalStatExersiceCount: number = 0,
                totalCorrectStatExersiceCount: number = 0,
                totalCorrectnessPercentage: number = 0,
                indexActivityCount: any = courseLearning?.exercises?.filter((eachActivity: any, index:number) => {
                    return eachActivity.type === "index";
                });
    
                const totalExercise = courseLearning?.exercises?.length - indexActivityCount.length,
                completedExerciseList = totalExercise && courseLearning?.exercises.filter(
                                                        (exercise: any , exerciseIndex: number) => exercise.Status === 2),
                completedExercise = completedExerciseList?.length,
                totalStatExersice = totalExercise && courseLearning?.exercises.map((exer:any,exerIndex: number) => {
                if(exer?.Stat != null){                    
                    return totalStatExersiceCount += isNaN(parseInt(exer.Stat.split(",")[2])) ? 0 : parseInt(exer.Stat.split(",")[2]);                            
                }
                }),
                completedStatExersice = totalExercise && courseLearning?.exercises.map((exer:any,exerIndex: number) => {
                if(exer?.Stat != null){                    
                    return totalCorrectStatExersiceCount += isNaN(parseInt(exer.Stat.split(",")[1])) ? 0 : parseInt(exer.Stat.split(",")[1]);  
                }
                });
                            
            totalCorrectnessPercentage = Math.round((totalCorrectStatExersiceCount / totalStatExersiceCount) * 100);                                                                
            perModuleTotalCorrectnessPercentage += isNaN(totalCorrectnessPercentage) ? 0 : totalCorrectnessPercentage;                    
            perModuleTotalExercise += isNaN(totalExercise) ? 0 : totalExercise;
            perModulecompletedExercise += isNaN(completedExercise) ? 0 : completedExercise;
            
            // cumulative total Exercise and completed Exercise for Units
            let cumulativeUnits = { 
                "type": "unit",
                "perUnitTotalExercise" : totalExercise,
                "perUnitcompletedExercise" : completedExercise,
                "totalCorrectnessPercentage": totalCorrectnessPercentage,
                "perUnitExercisePercentage" : completeBarTotalFormat(completedExercise, totalExercise, true),
                "perUnitExerciseDetails" : completeBarTotalFormat(completedExercise, totalExercise)
            }
            courseUnit = Object.assign({}, courseUnit, cumulativeUnits);
            
            }else{
                const totalSession = 1;
                const completedSessionCheck = totalSession && courseLearning?.sessionDetails?.Status;
                const sessionStartTimeTimeStamp = totalSession && courseLearning?.sessionDetails?.StartTime;
                const sessionStartTime = getDateAndTimeFormat(sessionStartTimeTimeStamp);
                let completedSession: any = 0;
                
                if((completedSessionCheck === 2) || (completedSessionCheck === 3)){
                completedSession = 1;
                }
                
                perModuleTotalSession += isNaN(totalSession) ? 0 : totalSession;
                perModulecompletedSession += isNaN(completedSession) ? 0 : completedSession;
                
                cumulativeSessionUnits = {   
                "type": "unit",            
                "perUnitTotalSession" : totalSession,
                "perUnitcompletedSession" : completedSession,
                "sessionStartTime": sessionStartTime              
                }
    
                courseUnit = Object.assign({}, courseUnit, cumulativeSessionUnits);            
            } 
    
            courseUnitObj.push(courseUnit);                  
    
            } else {
            // Digital Test total Exercise and completed Exercise for Units
            let testDetail = courseLearning?.testDetails?.length && courseLearning?.testDetails;
            let competenceList: any = [];
            let competenceTotalPercentage: number = 0;
            if (!testDetail?.length) {
                cumulativeTestResults = {
                type: "digital_test",
                UserScore: 0,
                MaxScore: 0,
                competenceTotalPercentage: 0,
                perModuleExerciseDetail: completeBarTotalFormat(0, 0),
                perModuleCompletedPercent: completeBarTotalFormat(0, 0, true)
                }
                courseUnit = Object.assign({}, courseUnit, cumulativeTestResults);
                courseUnitObj.push(courseUnit);
                return;
            }
            {testDetail?.length && testDetail.map((currentTestResult: any) => {
                let testResult = currentTestResult?.Competence?.length ? currentTestResult : undefined;
                if (!testResult) {
                cumulativeTestResults = {
                    type: "digital_test",
                    UserScore: 0,
                    MaxScore: 0,
                    competenceTotalPercentage: 0,
                    perModuleExerciseDetail: completeBarTotalFormat(0, 0),
                    perModuleCompletedPercent: completeBarTotalFormat(0, 0, true)
                }
                courseUnit = Object.assign({}, courseUnit, cumulativeTestResults);
                return;
                }
                const totalDigitalTest = testResult?.Competence?.length && testResult?.Competence.map((competence: any) => {
                let competenceTitle: string = competence?.competency,
                    competenceCurrentScore: number = competence?.currentScore,
                    competenceMaxScore: number = competence?.maxScore,
                    competencePercentage: number = Math.round((competenceCurrentScore / competenceMaxScore) * 100),
                    competenceObj = {
                    competenceTitle,
                    competencePercentage
                    };
                    competenceList.push(competenceObj);
                    competenceTotalPercentage += competencePercentage; 
                });
                competenceTotalPercentage = Math.round(competenceTotalPercentage / testResult?.Competence.length);
                perModuleExerciseDetail = completeBarTotalFormat(testResult.UserScore, testResult.MaxScore);
                perModuleCompletedPercent = completeBarTotalFormat(testResult.UserScore, testResult.MaxScore, true);
                cumulativeTestResults = {
                type: courseLearning.type,
                UserScore: testResult.UserScore ?? 0,
                MaxScore: testResult.MaxScore ?? 0,
                competenceList,
                competenceTotalPercentage,
                perModuleExerciseDetail,
                perModuleCompletedPercent
                }
                courseUnit = Object.assign({}, courseUnit, cumulativeTestResults);
            });
            courseUnitObj.push(courseUnit);
            }}              
        });
        perModuleExerciseDetail = completeBarTotalFormat(perModulecompletedExercise, perModuleTotalExercise);
        perModuleSessionDetail = completeBarTotalFormat(perModulecompletedSession, perModuleTotalSession);
        perModuleCompletedPercent = completeBarTotalFormat(perModulecompletedExercise, perModuleTotalExercise, true);
        perModuleSessionPercent = completeBarTotalFormat(perModulecompletedSession, perModuleTotalSession, true);
        if (!isDigitalTest) {        
            // cumulative total Exercise and completed Exercise for Module         
            perModuleCorrectnessPercentage = perModuleTotalCorrectnessPercentage/courseMainUnitList?.length;
            let cumulativeModules = { 
            "perModuleTotalExercise" : perModuleTotalExercise,
            "perModulecompletedExercise" : perModulecompletedExercise,
            "perModuleTotalSession": perModuleTotalSession,
            "perModulecompletedSession": perModulecompletedSession,
            "perModuleCorrectnessPercentage": perModuleCorrectnessPercentage,
            "perModuleSessionDetail" : perModuleSessionDetail,
            "perModuleExerciseDetail": perModuleExerciseDetail,
            "perModuleCompletedPercent" : perModuleCompletedPercent,
            "perModuleSessionPercent" : perModuleSessionPercent
            }
    
            courseDetailObj = Object.assign({}, courseDetailObj, cumulativeModules);
        } else {
            // Digital Test total Exercise and completed Exercise for Module
            courseDetailObj = Object.assign({}, courseDetailObj, cumulativeTestResults);
        }
        });
     
        courseDetailObj.units = Array.from(new Map(courseUnitObj.map((v: any) => [v.id, v])).values());
        // check if course object exists in array or not
        courseModuleObj.some((eachCourse: any, index: number) => {
        if (eachCourse?.courseTitle === courseMainTitle){        
            courseExist = true; 
            courseIndex = index; 
            perPartTotalExercise += isNaN(perModuleTotalExercise) ? 0 : perModuleTotalExercise;
            perPartCompletedExercise += isNaN(perModulecompletedExercise) ? 0 : perModulecompletedExercise;      
            perPartTotalSession += isNaN(perModuleTotalSession) ? 0 : perModuleTotalSession;
            perPartCompletedSession += isNaN(perModulecompletedSession) ? 0 : perModulecompletedSession;      
            perPartTotalCorrectnessPercentage += isNaN(perModuleCorrectnessPercentage) ? 0 : perModuleCorrectnessPercentage;  
            perPartUserScore += isNaN(cumulativeTestResults.UserScore) ? 0 : cumulativeTestResults.UserScore;      
            perPartMaxScore += isNaN(cumulativeTestResults.MaxScore) ? 0 : cumulativeTestResults.MaxScore;             
        } 
        });
        // forming course object
        let dialogContentLocal = (
        <div>
            <h6>{translate("progress_overall_card_title_certificate")}:</h6>
            <p>{translate("progress_badge_dialog_box_title")}</p>
            {(productId !== "25") && 
            <>
                <h6>{translate("progress_overall_card_title_badge")}:</h6>
                <ul>
                <li>{translate("progress_badge_dialog_box_golden")}</li>
                <li>{translate("progress_badge_dialog_box_silver")}</li>
                <li>{translate("progress_badge_dialog_box_bronze")}</li>
                </ul>
            </>
            }
            <p>
            {(productId === "21" || productId === "22"|| productId === "23"|| productId === "24") && <>*{translate("progerss_badge_dailog_box_digitalActivities")}.</>
            }
            {(productId == "20" || productId == "18") &&             
                <>*{translate("progress_badge_dailog_box_liveSessions")}.</>
            }
            {(productId == "25") && <>{translate("progress_elevate_dialog_box_liveSessions")}.</>}
            </p>
        </div>
        );
        let completedExercisePercent = Math.round((perPartCompletedExercise/perPartTotalExercise) * 100);
        let completedSessionPercent = Math.round((perPartCompletedSession/perPartTotalSession) * 100);
        let completedDigitalExercisePercent = Math.round((perPartUserScore/perPartMaxScore) * 100);
        let percentagePartCompletedExercise = isNaN(completedExercisePercent) ? 0 : completedExercisePercent;
        let percentagePartCompletedSession = isNaN(completedSessionPercent) ? 0 : completedSessionPercent;
        let percentagePartCompletedDigitalExercise = isNaN(completedDigitalExercisePercent) ? 0 : completedDigitalExercisePercent;    
        let certificateAvailability: any;
        if((productId === "20" || productId === "26"|| 
            productId === "27"|| productId === "28")) {
        certificateAvailability = (percentagePartCompletedExercise > 70) && (percentagePartCompletedSession > 70) ? true : false;
        } else {      
        certificateAvailability = (percentagePartCompletedExercise > 70) && (percentagePartCompletedDigitalExercise > 70) ? true : false;
        }
        if (!courseExist) {
        // new course      
        perPartTotalExercise = perModuleTotalExercise;
        perPartCompletedExercise = perModulecompletedExercise;
        perPartTotalSession = perModuleTotalSession;
        perPartCompletedSession = perModulecompletedSession;
        perPartTotalCorrectnessPercentage = perModuleCorrectnessPercentage;                 
        perPartUserScore = cumulativeTestResults.UserScore;      
        perPartMaxScore = cumulativeTestResults.MaxScore;
        perPartSessionDetail = completeBarTotalFormat(perPartCompletedSession, perPartTotalSession);
        courseModuleObj.push({
            courseTitle: courseMainTitle,
            certificateAvailability,
            dialogContentLocal,
            perPartTotalExercise,
            perPartCompletedExercise,
            perPartTotalSession,
            perPartCompletedSession,
            percentagePartCompletedExercise,
            percentagePartCompletedSession,
            perPartTotalCorrectnessPercentage,
            perPartUserScore,
            perPartMaxScore,
            perPartSessionDetail,
            courseDetailObj: [courseDetailObj]
        })
        } else {
        // existing course
        courseModuleObj[courseIndex].perPartTotalExercise = perPartTotalExercise;
        courseModuleObj[courseIndex].perPartCompletedExercise = perPartCompletedExercise;
        courseModuleObj[courseIndex].perPartTotalSession = perPartTotalSession;
        courseModuleObj[courseIndex].perPartCompletedSession = perPartCompletedSession;
        courseModuleObj[courseIndex].perPartSessionDetail = completeBarTotalFormat(perPartCompletedSession, perPartTotalSession);
        courseModuleObj[courseIndex].percentagePartCompletedExercise = percentagePartCompletedExercise;
        courseModuleObj[courseIndex].percentagePartCompletedSession = percentagePartCompletedSession;
        courseModuleObj[courseIndex].certificateAvailability = certificateAvailability;
        courseModuleObj[courseIndex].perPartTotalCorrectnessPercentage = perPartTotalCorrectnessPercentage;
        courseModuleObj[courseIndex].perPartUserScore = perPartUserScore;
        courseModuleObj[courseIndex].perPartMaxScore = perPartMaxScore;
        courseModuleObj[courseIndex].courseDetailObj.push(courseDetailObj);
        }        
    })
   
    courseModuleObj.map((eachCourse: any, index: number) => {
        let percentagePartCompletedExercise: any = 0;
        let perPartDigitalScorePercentage: any = 0;
        let perPartTotalCorrectnessPercentage: any = 0;
        let badgeAvailability: any = false;

        let courseCorrectObj = eachCourse?.courseDetailObj?.filter((eachDetailObj: any, index: number) => {
        return eachDetailObj.type === "module";
        });

        if(eachCourse?.perPartTotalCorrectnessPercentage) eachCourse.perPartTotalCorrectnessPercentage = (eachCourse?.perPartTotalCorrectnessPercentage)/ courseCorrectObj.length;

        if(eachCourse?.perPartUserScore && eachCourse?.perPartMaxScore) eachCourse.perPartDigitalScorePercentage = ((eachCourse?.perPartUserScore)/(eachCourse?.perPartMaxScore)) * 100;
        else eachCourse.perPartDigitalScorePercentage = 0;
        
        if(eachCourse?.percentagePartCompletedExercise) percentagePartCompletedExercise = (40*eachCourse?.percentagePartCompletedExercise)/100;
        if(eachCourse?.perPartDigitalScorePercentage) perPartDigitalScorePercentage = (40*eachCourse?.perPartDigitalScorePercentage)/100;
        if(eachCourse?.perPartTotalCorrectnessPercentage) perPartTotalCorrectnessPercentage = (20*eachCourse?.perPartTotalCorrectnessPercentage)/100;
        
        eachCourse.perPartBadgePercentage = Math.round(percentagePartCompletedExercise + perPartDigitalScorePercentage + perPartTotalCorrectnessPercentage);    
        if(eachCourse.perPartBadgePercentage >= 50){
        badgeAvailability = true;
        eachCourse.badgeAvailability = badgeAvailability;
        }else{
        eachCourse.badgeAvailability = badgeAvailability;
        }    
    });

    // return data
    return courseModuleObj;         
}
 
const completeBarTotalFormat = (completed: any = 0, total: any = 0, percent: boolean = false) => {
    if (percent) {
    const percent = Math.round((completed / total) * 100);
    const percentText = isNaN(percent) ? 0 : percent;
    return `${ percentText }%`;
    } else {
    return `(${completed} / ${total})`;
    }
}

const getDateAndTimeFormat =(timestamp: number) => {
    return moment
    .unix(timestamp)   
    .tz(moment.tz.guess(true)) 
    .format("DD MMMM YYYY | hh:mm A z");
}

// skills re-formated data
export function remapJSON(remappedJSON: any, progressDetails: any, userskillscourseslist: any, avoidMerging: boolean) {
    remappedJSON = {};
    remappedJSON.skilltitle = progressDetails.skill_name;
    remappedJSON.userid = progressDetails.user_id;
    remappedJSON.username = "";
    remappedJSON.skilllevel = progressDetails.level;
    remappedJSON.skillcourses = [];
    let course: any = {};
    progressDetails.skill_courses.map((unit: any) => {
        if (!!unit.skill_name) {
        course = {};
        course.subskillid = unit.sub_skill_id;
        course.usertestscore = unit.user_test_score ? unit.user_test_score : 0;
        course.maxtestscore = unit.max_test_score ? unit.max_test_score : 0;
        course.subskilltitle = unit.sub_skill_name;
        course.courseparttitle = unit.course_part_title;
        course.skilltypeid = unit.sub_skill_type;
        course.totalprework = unit.total_prework;
        course.preworkcompleted = unit.prework_completed;
        course.totalhomework = unit.total_homework ? unit.total_homework : 0;
        course.homeworkcompleted = unit.homework_completed;
        course.totalsession = unit.total_session ? unit.total_session : 0;
        course.sessioncompleted = unit.session_completed ? unit.session_completed : 0;
        course.sessionstatus = unit.session_status ? unit.session_status : 0;
        course.sessionCompletedDate = unit.session_completed_date;
        remappedJSON.skillcourses.push(course);
        }
    });
    if (avoidMerging) return remappedJSON;
    userskillscourseslist.data.userskillscourseslist.push(remappedJSON);

    // return data
    return userskillscourseslist;
}


export const separateIndivUnitCountBasedOnLevel = (allCompletedListUnitbefore: any) => {
    let structuredArr: any = [];
    let levelsList: any = [];
    if (allCompletedListUnitbefore && allCompletedListUnitbefore.length > 0) {
      allCompletedListUnitbefore.map((datum: any) => {
        if (levelsList.indexOf(datum.level) === -1) {
          let singleDataObj: any = {
            level: datum.level,
            prework: 0,
            totalprework: 0,
            sessions: 0,
            totalsessions: 0,
            units: [],
          };
          singleDataObj.units.push(datum);
          structuredArr.push(singleDataObj);
          levelsList.push(datum.level);
        } else {
          for (let i = 0; i < structuredArr.length; i++) {
            if (structuredArr[i].level === datum.level) {
              structuredArr[i].units.push(datum || {});
            }
          }
        }
      });
    }
    return structuredArr;
};


// sprint skills re-formated data
function sprintGroupSkillsObj(res: any) {    
    return Object.assign({
        title: res.title,
        level: res.level,
        productType: res.productType,
        getSkillsReport: sprintSkillsReportList(res.modules)
    });
}

function sprintSkillsReportList(skills: any) {
    let skillList = skills.map((skill: any) => {
        // if (skill.status !== 2) return;
        let prework = 0,
            homework = 0,
            sessions = 0,
            totalprework = 0,
            totalhomework = 0 ,
            totalsessions = 0;
        const skillUnitReport = sprintSubSkillsReportList(skill.id, skill.title, skill.units).map((unit: any) => {
                                    if (unit.hasSession) {
                                        prework += unit.preworkcompleted ?? 0,
                                        homework += unit.homeworkcompleted ?? 0,
                                        sessions += unit.sessioncompleted ?? 0,
                                        totalprework += unit.totalprework ?? 0,
                                        totalhomework = unit.totalhomework ?? 0,
                                        totalsessions += unit.totalsession ?? 0;
                                    }
                                });
        return (
            Object.assign({
                            prework,
                            homework,
                            sessions,
                            totalprework,
                            totalhomework,
                            totalsessions,
                            skillId: skill.id,
                            skilltitle: skill.title,
                            skillcourses: sprintSubSkillsReportList(skill.id, skill.title, skill.units)
                        })
        )
    })
    return skillList;
}

function sprintSubSkillsReportList(title: any, id: any, subSkills: any) {
    let subSkillList = subSkills.map((subskill: any) => {
        const totalLearning = totalLearningCalc(subskill.learningObjects);
        return Object.assign({
            skillId: title,
            skilltitle: id,
            subskillid: subskill.id,
            subskilltitle: subskill.title
        }, totalLearning)
    })
    return subSkillList;
}

function totalLearningCalc(learnObj: any) {
    let learnCount = {};
    learnObj.map((learn: any) => {
        switch (learn.type) {
            case "lesson":
                Object.assign(learnCount, lessonStatus(learn));
            break;

            case "session":
                Object.assign(learnCount, sessionStatus(learn));
            break;

            case "homework":
                Object.assign(learnCount, homeWorkStatus(learn));
            break;

            default:
              break;
        }
    })
    return learnCount;
}

function lessonStatus(lessons: any) {
    let currentPreworkTotal = lessons?.exercises.filter((exer: any) => exer.type !== "index").length ?? undefined;
    let currentPreworkCompleted = lessons?.exercises.filter((exer: any) => exer.type !== "index" && exer.Status === 2).length ?? undefined;
    if (currentPreworkTotal) {
        return Object.assign({
            totalprework: currentPreworkTotal,
            preworkcompleted: currentPreworkCompleted
        })
    }
}

function sessionStatus(session: any) {
    if (session?.sessionDetails) {
        return Object.assign({
            hasSession: true,
            sessionid: session.sessionDetails.SessionId,
            totalsession: 1,
            sessionstatus: session.sessionDetails.Status,
            sessioncompleted: session.sessionDetails.Status === 2 ? 1 : 0,
            sessioncompleteddate: session.sessionDetails.EndTime
        })
    } else {
        return Object.assign({
            hasSession: false
        })
    }
}

function homeWorkStatus(homework: any) {
    let currentHomeWorkTotal = homework?.missions?.length;
    if (currentHomeWorkTotal) {
        return Object.assign({
            totalhomework: currentHomeWorkTotal,
            homeworkcompleted: 0,
            reviewcompleted: 0
        })
    }
}

export const sprintSkillGroupsInfo = (data: any) => {
    const reStructuredData: any =  sprintGroupSkillsObj(data);
    return reStructuredData;
}